<template>
  <register-container style="height: 100%" :contentStyle="{ height: '100%', position: 'relative' }">
    <div
      style="
        margin: auto;
        max-width: 800px;
        position: absolute;
        inset: 0px;
        padding: 16px;
        height: fit-content;
        max-height: 100%;
        overflow: auto;
      "
      :style="{
        transform: `translateY(calc(-${$vuetify.breakpoint.smAndDown ? '70px' : '107px'} * 0.5))`,
      }"
      class="pa-4 text-center flex-grow-1"
    >
      <header class="mt-6" style="max-width: 400px; margin: auto">
        <div v-if="!intervention">
          <h2>Thanks for your interest!</h2>

          <p style="font-size: 0.8rem" class="mt-6">
            {{
              'Based on the information provided, we are unable to continue with the intake process.'
            }}
          </p>
          <p style="font-size: 0.7rem" class="mt-6 font-italic px-4">
            Please speak with your pharmacist if you have any questions.
          </p>
        </div>
        <div v-else>
          <h2>Your well-being is our priority.</h2>
          <p style="font-size: 0.8rem" class="mt-2">
            Thank you for your honesty during the intake process.
          </p>
          <p style="font-size: 0.8rem" class="mt-2">
            Based on your answers, we believe your immediate well-being requires focused attention
            that we cannot provide through this platform.
          </p>
          <v-alert color="error" text class="text-left">
            <p>If you are in immediate danger or a crisis, <b>help is available:</b></p>
            <ul>
              <li>Call 911 or go to the nearest emergency room.</li>
              <li>
                Call or Text 9-8-8: This is Canada’s national suicide and crisis hotline, available
                24/7.
              </li>
            </ul>
          </v-alert>
          <p>We wish you the very best on your path to wellness.</p>
        </div>
      </header>
      <div class="mt-12" style="gap: 8px">
        <HoverButton color="primary" @click="end" large>End intake</HoverButton>
        <div class="mt-4">
          <button @click="back" large active style="font-size: 0.9rem; text-decoration: underline">
            Back
          </button>
        </div>
      </div>
    </div>
  </register-container>
</template>
<script>
import HoverButton from '../components/HoverButton.vue';

import RegisterContainer from '../components/RegisterContainer.vue';

export default {
  name: 'IneligiblePatient',
  components: {
    HoverButton,
    RegisterContainer,
  },
  data() {
    return {
      breakupText:
        'Based on the information provided, we are unable to continue with the intake process.',
    };
  },
  methods: {
    back() {
      window.dispatchEvent(new CustomEvent('GO_PREVIOUS_PAGE'));
    },
    end() {
      window.dispatchEvent(new CustomEvent('GO_NEXT_PAGE'));
    },
  },
  computed: {
    intervention() {
      const { surveyAnswers } = this.$store.state.registration;
      const { suicide } = surveyAnswers;

      return suicide === 'Yes';
    },
  },
};
</script>
